var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 14.0999V16.5999C19.251 16.832 19.2011 17.0617 19.1034 17.2744C19.0058 17.487 18.8626 17.6779 18.6831 17.8348C18.5035 17.9917 18.2915 18.1112 18.0607 18.1855C17.8298 18.2599 17.5852 18.2875 17.3425 18.2666C14.65 17.988 12.0636 17.1117 9.79125 15.7083C7.6771 14.4288 5.88467 12.7217 4.54125 10.7083C3.06248 8.53426 2.14222 6.05908 1.855 3.48325C1.83314 3.25281 1.86189 3.02055 1.93944 2.80127C2.01699 2.58199 2.14163 2.38049 2.30542 2.2096C2.46922 2.03871 2.66858 1.90218 2.89082 1.80869C3.11306 1.7152 3.3533 1.6668 3.59625 1.66658H6.22125C6.6459 1.6626 7.05757 1.80582 7.37954 2.06953C7.70152 2.33324 7.91182 2.69946 7.97125 3.09992C8.08205 3.89997 8.28752 4.68552 8.58375 5.44158C8.70148 5.73985 8.72696 6.06401 8.65717 6.37565C8.58738 6.68729 8.42526 6.97334 8.19 7.19992L7.07875 8.25825C8.32436 10.3445 10.1381 12.072 12.3288 13.2583L13.44 12.1999C13.6779 11.9759 13.9783 11.8215 14.3055 11.755C14.6327 11.6885 14.9731 11.7128 15.2863 11.8249C16.0801 12.107 16.9049 12.3027 17.745 12.4083C18.17 12.4654 18.5582 12.6693 18.8357 12.9812C19.1132 13.2931 19.2606 13.6912 19.25 14.0999Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bac0510935f0529a3f6690c99a2738e5.svg";
export { ForwardRef as ReactComponent };